
import { repository } from 'src/jtech/jtech-repository'

export const ServiceRequestRepository = {

  nmInterfaceConsumerUnitAddressAlterar: 'consumerUnitAddress.alterar',
  nmInterfaceConsumerUnitAddressGravar: 'consumerUnitAddress.gravar',
  nmInterfaceConsumerUnitSearchConsumerUnitAddress: 'consumerUnit.searchConsumerUnitAddress',

  loadForm: async function (params) {
    return await repository.resolve(params.id ? this.nmInterfaceConsumerUnitAddressAlterar : this.nmInterfaceConsumerUnitAddressGravar, {
      ...params
    })
  },

  loadCards: async function (params) {
    return await repository.resolveLogic(this.nmInterfaceConsumerUnitSearchConsumerUnitAddress, {
      ...params
    })
  },

  createAddress: async function (params) {
    return await repository.create(this.nmInterfaceConsumerUnitAddressGravar, {
      ...params
    })
  },

  updateAddress: async function (params) {
    return await repository.update(this.nmInterfaceConsumerUnitAddressAlterar, {
      ...params
    })
  }

}
